<template>
    <div class="static-map">
        <img src="@/assets/map.png" class="static-map__image" />
    </div>
</template>

<script>
export default {
    name: 'StaticMap',
    props: {
        mapData: Array
    }
}
</script>

<style lang="less" scoped>
.static-map {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.static-map__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/view/sum/map.vue